module.exports = __webpack_public_path__ + "static/img/gl-6.b11a7e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-6.jpg
// module id = rtZ8
// module chunks = 0